import React from 'react'
import ModalUI from '../../../widgets/layout/ModalUI'
import EmptyListUI from '../../../widgets/output/EmptyListUI'
import './AdjustmentTransactionsModal.css'

const AdjustmentTransactionsModalUI = ({ context, isOpen, onRequestClose, title, transactionList, totalAmount, viewPageUrl }) => {
  const transactionCount = transactionList ? transactionList.length : 0

  return (
    <ModalUI
      context={context}
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      titleLabel={title}
    >
      <div className='adjustment-transactions-modal'>
        {transactionList && transactionList.length > 0 && (
          <div className='adjustment-transactions-modal-header'>
            {viewPageUrl && (
              <a 
                href={viewPageUrl} 
                target="_blank" 
                rel="noopener noreferrer"
                className='adjustment-transactions-modal-link'
              >
                <i className='icon-external-link'></i>
                Open Page
              </a>
            )}
            <span className='adjustment-transactions-modal-count'>
              {transactionCount} {transactionCount === 1 ? 'transaction' : 'transactions'}
            </span>
          </div>
        )}
        {transactionList && transactionList.length > 0 ? (
          <div className='transaction-table-container'>
            <table className='escrow-table'>
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Particulars</th>
                  <th>Amount</th>
                  <th>Type</th>
                  <th>Reconciliation Status</th>
                </tr>
              </thead>
              <tbody>
                {transactionList.map((txn, i) => (
                  <tr key={i}>
                    <td>{txn.transactionDateF || txn.transactionDateISO}</td>
                    <td>{txn.particulars}</td>
                    <td>{txn.amountF1 || txn.amountF2}</td>
                    <td>{txn.climeTxnType}</td>
                    <td>{txn.reconciliationStatus}</td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr>
                  <td colSpan="2">Total</td>
                  <td>₹ {totalAmount || '0'}</td>
                  <td colSpan="2"></td>
                </tr>
              </tfoot>
            </table>
          </div>
        ) : (
          <EmptyListUI
            context={context}
            createEnabled={false}
            createDisabledMessageLabel='No transactions'
          />
        )}
      </div>
    </ModalUI>
  )
}

export default AdjustmentTransactionsModalUI

